import React from "react";
import "../styles/Projects.css";
import FolderOpenRoundedIcon from "@material-ui/icons/FolderOpenRounded";
import FadeInSection from "./FadeInSection";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import ExternalLinks from "./ExternalLinks";

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }
  render() {
    const projects = {
      Crumb: {
        desc: "Crumb is a smart calorie tracker that makes food logging simple. Type what you ate, and our AI gives you instant calories, macros, and nutrition insights.",
        open: "https://apps.apple.com/us/app/crumb-calorie-counter/id6754396931",
      },

      "Maze A.I": {
        desc:
          "A self-learning A.I. that learns to traverse through a maze by the genetic algorithm.",
        techStack: "JavaScript, HTML/CSS, Genetic algorithm",
        link: "https://github.com/Francis220/Maze-AI",
        open: "https://francis220.github.io/Maze-AI/",
      },

      "Cryptocurrency Trading Bot": {
        desc:
          "A trading bot to automate cryptocurrency trading strategies using Python, equipped with a basic GUI.",
        techStack: "Python",
        link: "https://github.com/Francis220/Crypto",
      },
    };

    return (
      <div id="projects">
        <div className="section-header ">
          <span className="section-title">/ fun projects</span>
        </div>
        <div className="project-container">
          <ul className="projects-grid">
            {Object.keys(projects).map((key, i) => (
              <FadeInSection delay={`${i + 1}00ms`}>
                <li className="projects-card">
                  <div className="card-header">
                    <div className="folder-icon">
                      <FolderOpenRoundedIcon
                        style={{ fontSize: 35 }}
                      ></FolderOpenRoundedIcon>
                    </div>
                    <ExternalLinks
                      githubLink={projects[key]["link"]}
                      openLink={projects[key]["open"]}
                    ></ExternalLinks>
                  </div>
                  <div className="card-title">{key}</div>
                  <div className="card-desc">{projects[key]["desc"]}</div>
                  {projects[key]["techStack"] && (
                    <div className="card-tech">{projects[key]["techStack"]}</div>
                  )}
                </li>
              </FadeInSection>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Projects;
